import { MapViewer } from '@3ddv/dvm-internal';
import { Component, inject, input } from '@angular/core';
import { SeatWithDefinitions } from '@core/models';
import { DvmService } from '@features/digital-venue/services/dvm.service';
import { ConnectionService } from '@features/pages/select-seat/services/connection.service';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';

@Component({
  standalone: false,
  selector: 'app-restricted-seats-modal',
  templateUrl: './restricted-seats-modal.component.html',
  styleUrl: './restricted-seats-modal.component.css',
})
export class RestrictedSeatsModalComponent {
  private dialogRef = inject(BrnDialogRef);
  dvmService = inject(DvmService);
  connectionService = inject(ConnectionService);

  mapViewer: MapViewer = this.dvmService.viewer;

  readonly title = input<string>('Warning !');
  readonly acceptFunc = input<(() => void) | undefined>(undefined);
  readonly seats = input<SeatWithDefinitions[]>([]);

  close() {
    this.dialogRef.close();
  }

  continue() {
    const fn = this.acceptFunc();
    if (fn) {
      fn();
    }
    this.dialogRef.close();
  }
}
